import styled, { keyframes } from 'styled-components';
import ReactModal from 'react-modal';
import React from 'react';
import PropTypes from 'prop-types';

import { mq, getSpace, getColor } from '../../../stylesheets/tools';

const ReactModalAdapter = ({ className, modalClassName, ...props }) => {
  return <ReactModal className={modalClassName} portalClassName={className} {...props} />;
};

ReactModalAdapter.propTypes = {
  modalClassName: PropTypes.string,
  className: PropTypes.string
};

const progress = keyframes`
  0% {
    transform: scaleX(0);
  }

  100% {
    transform: scaleX(1);
  }
`;

const StyledRoomOfQuestions = styled(ReactModalAdapter).attrs({
  overlayClassName: {
    base: 'roomOfQuestions__overlay',
    afterOpen: 'roomOfQuestions__overlay--after-open',
    beforeClose: 'roomOfQuestions__overlay--before-close'
  },
  modalClassName: 'roomOfQuestions__content'
})`
  .roomOfQuestions__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 100;
    pointer-events: auto;
    background: ${getColor('black')};
    color: ${getColor('white')};
    opacity: 1;
    transition: opacity 400ms ease-in-out;
  }

  .roomOfQuestions__overlay--after-open {
    opacity: 1;
  }

  .roomOfQuestions__overlay--before-close {
    opacity: 0;
  }
  .roomOfQuestions__content {
    position: relative;
    z-index: 3;
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .roomOfQuestions__inner-content {
    height: 100vh;
    width: 100%;
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-rows: repeat(11, 1fr);
    grid-template-columns: 1fr;
    text-align: center;

    & > div {
      align-self: center;
      justify-self: center;
    }
  }

  button,
  .roomOfQuestions__content {
    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  .roomOfQuestions__close {
    position: absolute;
    top: ${getSpace('l')};
    right: 24px;
    z-index: 100;

    ${mq('m')} {
      right: 60px;
      width: 34px;
      height: 35px;
    }

    svg {
      width: 24px;
      height: 24px;
      margin-top: 4px;
      color: ${getColor('white')};

      ${mq('m')} {
        width: 34px;
        height: 35px;
        margin-top: 0;
      }
    }
  }

  .roomOfQuestions__skip {
    position: absolute;
    bottom: ${getSpace('l')};
    display: flex;
    align-items: center;
    right: 24px;
    z-index: 100;
    color: ${getColor('white')};
    transition: opacity 0.4s ease-in-out;

    ${mq('m')} {
      right: 60px;
    }

    svg {
      color: ${getColor('white')};
      margin-right: ${getSpace('xxs')};
    }
  }

  .roomOfQuestions__progress {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: ${getColor('white')};
    transform-origin: left center;
    animation: ${progress} 30s linear forwards;
  }
`;

export default StyledRoomOfQuestions;
